const bag = document.querySelector('[data-cart-count]') ?? false;

const updateBagCount = () => {
  if (!bag) {
    return;
  }

  fetch(`${window.Shopify.routes.root}cart.js`)
    .then(response => response.json())
    .then(data => {
      bag.innerHTML = data.item_count;
    });
};

export default updateBagCount;
